<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <div>
            <el-button no="1" type="primary" :disabled="readonly" @click="pm.addBtnClickHandler()">{{ $t('SeaExport.Add2') }}</el-button>
            <el-button no="2" type="danger" :disabled="readonly" @click="pm.delBtnClickHandler()">{{ $t('SeaExport.Delete') }}</el-button>
            <el-button no="3" type="primary" @click="pm.downTemplateBtn_clickHandler()">{{ $t('SeaExport.TemplateDownload') }}</el-button>

            <el-upload
              :disabled="readonly"
              :action="URL.seaExport.poItemsImportExcel"
              :headers="{sessionId:user.sessionId}"
              :data="{ jobUuid: job.uuid, jobNo: job.jobNo }"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
              style="display: inline-block;padding-left: 5px;"
            >
              <el-button type="primary" :disabled="readonly">{{ $t('SeaExport.ExcelImport') }}</el-button>
            </el-upload>
            <el-button no="4" type="primary" @click="pm.exportBtnClickHandler()">{{ $t('SeaExport.ExcelExport') }}</el-button>
            <el-button no="5" type="success" @click="pm.onBatchPrint()">{{ $t('SeaExport.print') }}</el-button>
            <el-button no="6" type="primary" :disabled="isEdit" @click="pm.relatedContainerHandler()">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="7" type="primary" :disabled="isEdit" @click="pm.removeRelatedContainerHandler()">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
        </cargo-button-group-slider>
      </div>
    </div>
    <div class="section" style="flex: 1;">
      <cargo-ag-grid
        config-module="130122"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="poItems"
        :wrap-text="true"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 添加装箱信息弹出窗 -->
    <trade-detail-container-linked-dialog
      :visible.sync="tradeDetailContainerLinkedDialog.visible"
      :job="job"
      :sel-po-items="tradeDetailContainerLinkedDialog.selPoItems"
      :related-container-usage="tradeDetailContainerLinkedDialog.relatedContainerUsage"
      @linkUsagesEventHandler="linkUsagesEventHandler"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { TabTradeDetailBase } from './TabTradeDetailBase'
import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import TradeDetailContainerLinkedDialog from '@/components/Cargo/Job/tradeDetailContainerLinkedDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { basicCacheKeys, basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'TabTradeDetail',
  components: { CargoButtonGroupSlider, TradeDetailContainerLinkedDialog, cargoTemplateSelectorDialog, CargoAgGridAdvanceSelectEditor },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      pm: new TabTradeDetailBase(this),
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        singleClickEdit: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { // 添加编辑组件
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor,
          CargoAgGridCommonTextareaEditor
        },
        onRowDragEnd: this.refreshSequenceNo
      },
      rowData: [],
      gridApi: null,
      tradeDetailContainerLinkedDialog: {
        visible: false,
        selPoItems: [],
        relatedContainerUsage: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new IntegratedJob(),
        category: 'SEPOITEMS',
        data: {
          POITEMS_UUID: []
        }
      },
      job: new Job().fillDefaultValue().getData(),
      poItems: [],
      delPoItemsUuids: [], // 删除的uuid
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    language() {
      return this.$store.getters.language
    },
    config() {
      return this.context.config
    },
    columnDefs() {
      const columnDefs =
         [
           {
             headerName: this.$t('SeaExport.SequenceNumber'),
             initialWidth: 130,
             checkboxSelection: true,
             rowDrag: this.isEdit,
             colId: 'sequenceNo',
             field: 'sequenceNo',
             sortable: true,
             suppressMenu: true,
             suppressSizeToFit: true,
             headerCheckboxSelection: true,
             lockVisible: true,
             initialHide: false,
             wrapText: false // 去除因拖拽而导致的行自动撑高
           },
           {
             headerName: this.$t('SeaExport.ContainerSize'),
             headerTooltip: this.$t('SeaExport.ContainerSize'),
             field: 'eqSize',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.ContainerType'),
             headerTooltip: this.$t('SeaExport.ContainerType'),
             field: 'eqType',
             width: 110
           },
           {
             headerName: this.$t('SeaExport.ContainerNo'),
             headerTooltip: this.$t('SeaExport.ContainerNo'),
             field: 'containerNo',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.SealNo'),
             headerTooltip: this.$t('SeaExport.SealNo'),
             field: 'sealNo',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.OrderNo'),
             headerTooltip: this.$t('SeaExport.OrderNo'),
             colId: 'orderNo',
             field: 'orderNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ACPT',
             headerTooltip: 'ACPT',
             field: 'moduleCode',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CaseNo'),
             headerTooltip: this.$t('SeaExport.CaseNo'),
             field: 'caseNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Item'),
             headerTooltip: this.$t('SeaExport.Item'),
             field: 'itemNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Sub'),
             headerTooltip: this.$t('SeaExport.Sub'),
             field: 'subItemNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'SUPPLY PARTS NO',
             headerTooltip: 'SUPPLY PARTS NO',
             field: 'supplyPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ORDER PARTS NO',
             headerTooltip: 'ORDER PARTS NO',
             field: 'orderPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'HS CODE',
             headerTooltip: 'HS CODE',
             field: 'hsCode',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.isRelated'),
             headerTooltip: this.$t('SeaExport.isRelated'),
             field: 'related',
             width: 120,
             cellRenderer: (params) => {
               return this.relatedLabelFunc(params.value)
             }
           },
           {
             headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
             headerTooltip: this.$t('SeaExport.ChineseDescriptionOfGoods'),
             field: 'chineseCommodity',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
             colId: 'englishCommodity',
             field: 'englishCommodity',
             width: 120,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor',
             cellEditorParams: {
               autoUppercase: this.isUppercaseByConfig
             },
             onCellValueChanged: p => this.onCellChange(p)
           },
           {
             headerName: this.$t('SeaExport.Size2'),
             headerTooltip: this.$t('SeaExport.Size2'),
             field: 'itemSpec',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CommodityClassification'),
             headerTooltip: this.$t('SeaExport.CommodityClassification'),
             field: 'customsCommodity',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Qty'),
             headerTooltip: this.$t('SeaExport.Qty'),
             field: 'quantity',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.UnitOfMeasurement'),
             headerTooltip: this.$t('SeaExport.UnitOfMeasurement'),
             field: 'measure',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.NetWeight'),
             headerTooltip: this.$t('SeaExport.NetWeight'),
             field: 'netWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'WEIGHT',
             headerTooltip: 'WEIGHT',
             field: 'grossWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.Cubage'),
             headerTooltip: this.$t('SeaExport.Cubage'),
             field: 'cubage',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'AMOUNT',
             headerTooltip: 'AMOUNT',
             field: 'purchaseAmount',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'AMOUNT(RMB)',
             headerTooltip: 'AMOUNT(RMB)',
             field: 'purchaseAmountRMB',
             width: 150,
             cellRenderer: (params) => {
               return this.purchaseAmountRMBLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDutyRate'),
             headerTooltip: this.$t('SeaExport.CustomsDutyRate'),
             field: 'purchaseTariffRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDuties'),
             headerTooltip: this.$t('SeaExport.CustomsDuties'),
             field: 'purchaseTariffAmount',
             width: 120
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDutyRate'),
             headerTooltip: this.$t('SeaExport.IncrementValueDutyRate'),
             field: 'purchaseValRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 // complexTextConverter: (data, val) => {
                 //   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 // },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDuty'),
             headerTooltip: this.$t('SeaExport.IncrementValueDuty'),
             field: 'purchaseValAmount',
             width: 120
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDutyRate'),
             headerTooltip: this.$t('SeaExport.ConsumptionDutyRate'),
             field: 'purchaseExciseRate',
             width: 110,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDuty'),
             headerTooltip: this.$t('SeaExport.ConsumptionDuty'),
             field: 'purchaseExciseAmount',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.ConsolidatedTax'),
             headerTooltip: this.$t('SeaExport.ConsolidatedTax'),
             field: 'totalRateAmount',
             width: 100,
             cellRenderer: (params) => {
               return this.totalRateAmountLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.Currency'),
             headerTooltip: this.$t('SeaExport.Currency'),
             field: 'purchaseCurrency',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               clearable: false,
               isEdit: this.isEdit,
               tag: 'cargo-advance-select',
               selectType: selectTypeNames.basic_data_Currency,
               tagValue: 'code',
               tagName: 'code'
             }
           },
           {
             headerName: this.$t('SeaExport.ExchangeRate'),
             headerTooltip: this.$t('SeaExport.ExchangeRate'),
             field: 'pruchaseExchangeRate',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 6))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CargoPrice'),
             headerTooltip: this.$t('SeaExport.CargoPrice'),
             field: 'sellPrice',
             width: 100,
             cellRenderer: (params) => {
               return params.data ? ColumnUtils.numberColumnLabelFunc(params.data.sellPrice, 2) : 0.00
             },
             cellStyle: () => {
               return { backgroundColor: '#EEEEEE' }
             }
           },
           {
             headerName: this.$t('SeaExport.Tax'),
             headerTooltip: this.$t('SeaExport.Tax'),
             field: 'sellValAmount',
             width: 100,
             cellRenderer: (params) => {
               return params.data ? ColumnUtils.numberColumnLabelFunc(params.data.sellValAmount, 2) : 0.00
             },
             cellStyle: () => {
               return { backgroundColor: '#EEEEEE' }
             }
           },
           {
             headerName: this.$t('SeaExport.TaxRate'),
             headerTooltip: this.$t('SeaExport.TaxRate'),
             field: 'sellValRate',
             width: 100,
             cellStyle: () => {
               return { backgroundColor: '#EEEEEE' }
             }
           },
           {
             headerName: this.$t('SeaExport.Marks'),
             headerTooltip: this.$t('SeaExport.Marks'),
             field: 'mark',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 isUppercase: this.isUppercaseByConfig
               }
             }
           },
           {
             headerName: this.$t('SeaExport.Package'),
             headerTooltip: this.$t('SeaExport.Package'),
             field: 'packing',
             width: 100,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridAdvanceSelectEditor',
             cellEditorParams: {
               selectProps: {
                 selectType: TYPE_NAMES.basic_data_Packing,
                 filterable: true,
                 tagValue: 'code',
                 customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
                 showCustomLabelInOption: true
               }
             },
             onCellValueChanged: (params) => {
               this.onCellChange(params)
             },
             valueFormatter: params => {
               return ColumnUtils.packingCodeLabelFun(params.value)
             }
           },
           {
             headerName: this.$t('SeaExport.SerialNumber'),
             headerTooltip: this.$t('SeaExport.SerialNumber'),
             field: 'serialNumber',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Brand'),
             headerTooltip: this.$t('SeaExport.Brand'),
             field: 'brand',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.ProductiveYear'),
             headerTooltip: this.$t('SeaExport.ProductiveYear'),
             field: 'productiveYear',
             hide: true,
             width: 150,
             cellEditor: 'CargoAgGridSelectEditor',
             editable: this.isEdit,
             cellEditorParams: {
               options: this.clnYears(),
               tagName: 'name',
               tagValue: 'value'
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsValue'),
             headerTooltip: this.$t('SeaExport.CustomsValue'),
             field: 'customsValue',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.UnitType'),
             headerTooltip: this.$t('SeaExport.UnitType'),
             field: 'unitType',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.DeviceType'),
             headerTooltip: this.$t('SeaExport.DeviceType'),
             field: 'deviceType',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CountryOrigin1'),
             headerTooltip: this.$t('SeaExport.CountryOrigin1'),
             field: 'countryOrigin',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.DeviceStatus'),
             headerTooltip: this.$t('SeaExport.DeviceStatus'),
             field: 'deviceStatus',
             hide: true,
             width: 150,
             cellEditor: 'CargoAgGridSelectEditor',
             editable: this.isEdit,
             cellEditorParams: {
               options: [{ name: this.$t('SeaExport.BrandNew'), value: 0 }, { name: this.$t('SeaExport.SecondHand'), value: 1 }],
               tagName: 'name',
               tagValue: 'value'
             },
             valueFormatter: params => {
               return params.value === 0 ? this.$t('SeaExport.BrandNew') : this.$t('SeaExport.SecondHand')
             }
           },
           {
             headerName: 'L(cm)',
             headerTooltip: 'L(cm)',
             field: 'lengthCm',
             hide: true,
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'W(cm)',
             headerTooltip: 'W(cm)',
             field: 'weightCm',
             hide: true,
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'H(cm)',
             headerTooltip: 'H(cm)',
             field: 'heigthCm',
             hide: true,
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'Caro Text',
             headerTooltip: 'Caro Text',
             field: 'cargoText',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'Chassis No.',
             headerTooltip: 'Chassis No.',
             field: 'chassisNo',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'NEW/USED',
             headerTooltip: 'NEW/USED',
             field: 'newOrUsed',
             hide: true,
             width: 150,
             cellEditor: 'CargoAgGridSelectEditor',
             editable: this.isEdit,
             cellEditorParams: {
               options: [{ name: 'NEW', value: 'NEW' }, { name: 'USED', value: 'USED' }],
               tagName: 'name',
               tagValue: 'value'
             },
             valueFormatter: params => {
               return params.value
             }
           },
           {
             headerName: 'Propulsion Type',
             headerTooltip: 'Propulsion Type',
             field: 'propulsionType',
             hide: true,
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               clearable: true,
               isEdit: this.isEdit,
               tag: 'cargo-advance-select',
               selectType: selectTypeNames.basic_data_PropulsionType,
               tagValue: 'code',
               tagName: 'code'
             }
           },
           {
             headerName: this.$t('SeaExport.PackageDisplayName'),
             headerTooltip: this.$t('SeaExport.PackageDisplayName'),
             field: 'packingName',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           }
         ]
      return columnDefs
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      await this.pm.loadPoItems()
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { poItems: deepCopy(this.job.poItems) })
      }
      this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    },
    // 保存
    getSubmitData() {
      return {
        job: this.job,
        poItems: this.poItems,
        delPoItemsUuids: this.delPoItemsUuids
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.pm.onImportSucceeded(response.data)
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    relatedLabelFunc(value) {
      return value === 1 ? this.$t('Message.Yes') : this.$t('Message.No')
    },
    clnYears() {
      const arrYear = []
      arrYear.push({ name: this.$t('SeaExport.Unknown'), value: '不详' })
      const date = new Date().getFullYear()
      for (let i = date; i >= date - 30; i--) {
        arrYear.push({ name: i.toString(), value: i.toString() })
      }
      return arrYear
    },
    totalRateAmountLabelFun(data) {
      const poItems = data
      if (poItems) {
        return Number(poItems.purchaseTariffAmount + poItems.purchaseValAmount + poItems.purchaseExciseAmount).toFixed(2)
      }
      return ''
    },
    purchaseAmountRMBLabelFun(data) {
      var poItems = data
      if (poItems) {
        return (Math.round(poItems.purchaseAmount * poItems.pruchaseExchangeRate)).toFixed(2)
      }
      return ''
    },
    // 添加装箱信息(选择后逻辑处理)
    linkUsagesEventHandler(data) {
      this.pm.linkUsagesEventHandler(data)
    },
    // 刷新每行行号
    refreshSequenceNo() {
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          const poItems = node.data
          poItems.sequenceNo = node.rowIndex + 1
        })
        this.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 列编辑修改事件
    async onCellChange(params) {
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }
      const poItems = newParams.data
      if (newParams.field === 'packing') {
        if (poItems.packing) {
          const packingList = await getSpecificBasicData(basicCacheKeys.basic_data_Packing)
          if (packingList && packingList.length > 0) {
            const item = packingList.find(p => p.code === poItems.packing)
            if (item) {
              poItems.packingName = item.name
            } else {
              poItems.packingName = ''
            }
          }
        } else {
          poItems.packingName = ''
        }
      }
    }
  }
}
</script>

<style>
</style>
